<script>
import exchangeBidApi from '@/api/exchangeBid';
import materialOrderApi from '@/api/materialOrder';
import exchangeResponseApi from '@/api/exchangeResponse';

import Default from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';
import DecorCategorySelector from '@/components/exchange/material/MaterialCategorySelector.vue';
import DecorOrdersPopup from '@/components/exchange/MaterialOrdersPopup.vue';
import MaterialTile from '@/components/exchange/MaterialTile.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import BasePopup from '@/components/BasePopup.vue';
import ExchangeBidForm from '@/components/exchange/ExchangeBidForm.vue';
import ExchangeBidTile from '@/components/exchange/ExchangeBidTile2.vue';

export default {
  name: 'ExchangeOrderDetail',
  components: {
    ExchangeBidForm,
    DecorOrdersPopup,
    BasePopup,
    BaseCheckbox,
    DecorCategorySelector,
    CommonSection,
    Default,
    MaterialTile,
    ExchangeBidTile,
  },
  data() {
    return {
      order: null,
      response: null,
      bids: [],
    };
  },
  mounted() {
    this.reload();
  },
  computed: {
    materials() {
      return this.order.materials.map(m => {
        const bid = (this.response?.bids ?? []).find(b => b.material === m['@id']);
        return { ...m, bid };
      });
    },
  },
  methods: {
    reload() {
      const order = this.$route.params.orderId;
      materialOrderApi.fetchItem(order, {}, true).then(r => { this.order = r; });
      exchangeResponseApi.fetchList({ order }, true).then(r => { this.response = r.items[0] ?? null; });
    },
    async createResponse() {
      const order = materialOrderApi.getIri(this.$route.params.orderId);
      this.response = await exchangeResponseApi.create({ order, status: '' }, true);
    },
    async deleteResponse() {
      await exchangeResponseApi.delete(this.response.id, true);
      this.response = null;
    },
    async createBid(material) {
      const res = await this.$refs.responsePopup.open();

      if (!res) return;

      await exchangeBidApi.create({
        ...res,
        material: material['@id'],
        response: this.response['@id'],
      }, true);
      this.reload();
    },
    async editBid(bid) {
      const res = await this.$refs.responsePopup.open(bid);

      if (!res) return;

      await exchangeBidApi.update(bid.id, res, true);
      this.reload();
    },
    async deleteBid(bid) {
      await exchangeBidApi.delete(bid.id, true);
      this.reload();
    },
  },

};
</script>

<template lang="pug">
  Default(v-if="order")
    CommonSection(:title="`Заказ ${order.name}`")
      ExchangeBidForm(ref="responsePopup")
      .response(v-if="response") Отклик создан
        Btn(@click="deleteResponse") Удалить отклик
      .response(v-else)
        Btn(@click="createResponse") Создать отклик

      .materials
        MaterialTile(
          v-for="material in materials"
          :key="material.id"
          :item="material"
        )
          ExchangeBidTile(
            v-if="material.bid"
            :item="material.bid"
            editable
            @edit="editBid(material.bid)"
            @delete="deleteBid(material.bid)"
          )
          Btn(v-else-if="response" @click="createBid(material)") Сделать предложение
</template>

<style scoped lang="scss">
  .orders {
    display: grid;
    gap: 30px;
  }

  .order {
    padding: 30px;
    border-radius: 30px;
    border: 1px solid black;
  }

  .items-title, .responses-tile {
    margin-top: 40px;
  }

  .items, .responses {
    display: grid;
    gap: 30px;
  }
</style>
